import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalendarPopupRoutingModule } from './calendar-popup-routing.module';
import { CalendarPopupComponent } from './calendar-popup.component';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from '../calendar/calendar.module';
import { FullCalendarModule } from '@fullcalendar/angular';


@NgModule({
  declarations: [
    CalendarPopupComponent
  ],
  imports: [
    CommonModule,
    CalendarPopupRoutingModule,
    FullCalendarModule,
    DropdownModule,
    CardModule,
    FormsModule,
    ButtonModule,
    FontAwesomeModule,
    MultiSelectModule,
    CalendarModule
  ]
})
export class CalendarPopupModule { }
